import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, Reveal } from "../../lib/site";
import { scrollTo } from "./Navbar";

const Card = ({ cat }) => {
  const Icon = cat.icon;
  return (
    <motion.button
      data-testid={`category-card-${cat.key}`}
      onClick={() => scrollTo("contact")}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      className={`group relative overflow-hidden rounded-3xl min-h-[300px] text-left ${cat.span}`}
    >
      <img
        src={cat.img}
        alt={cat.name}
        className="absolute inset-0 h-full w-full object-cover grayscale-[35%] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#061122] via-[#0B1F3A]/70 to-transparent" />
      <div className="relative z-10 flex h-full flex-col justify-between p-7 min-h-[300px]">
        <div className="flex items-center justify-between">
          <span className="grid h-12 w-12 place-items-center rounded-full glass text-gold">
            <Icon size={22} />
          </span>
          <ArrowUpRight className="text-white/60 transition-all duration-300 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
        <div>
          <h3 className="font-display text-2xl md:text-3xl font-medium text-white">{cat.name}</h3>
          <p className="mt-2 max-w-md text-sm text-slate-200 opacity-0 translate-y-3 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
            {cat.blurb}
          </p>
        </div>
      </div>
    </motion.button>
  );
};

export const Categories = () => {
  return (
    <section id="categories" data-testid="categories-section" className="bg-navy-deep py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <Reveal>
            <span className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold">
              02 — Our Categories
            </span>
            <h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-white">
              Products we trade
            </h2>
          </Reveal>
          <Reveal delay={1}>
            <p className="max-w-sm text-slate-300 leading-relaxed">
              Carefully selected categories where our sourcing expertise and quality controls make the biggest difference.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          {CATEGORIES.map((c) => (
            <Card key={c.key} cat={c} />
          ))}
        </div>
      </div>
    </section>
  );
};
